import { asyncAction } from 'lib/actionCreators'

export const candidateProfileView = asyncAction('candidate/CANDIDATE_PROFILE_VIEW')
